import { Button } from "@vds/buttons";
import styled from "styled-components";
import { device } from "../../../styles/breakpoints";

//DashBoardEventRow.jsx

export const EventsTile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ isExpanded, isFloorPlan, isHighPriority }) => (isExpanded && !isFloorPlan ? "auto" : isHighPriority ? "115px" : "110px")};
  padding: 12px;
  border-radius: 8px;
  background: var(--vds-background-primary-light, #fff);
  margin: 0 auto 12px;
  max-width: 95%;
  transition:
    height 0.3s ease,
    max-width 0.3s ease,
    transform 0.3s ease;

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
      max-width: 93%;
      transform: scale(1.02);
    `}
  gap: 16px;

  /* Tablet: More spacing and width */
  @media ${device.tablet} {
    padding: 14px;
    margin-bottom: 14px;
    gap: 18px;
    max-width: 95%;
  }

  /* Desktop: Full spacing */
  @media ${device.desktop} {
    padding: 16px;
    margin-bottom: 16px;
    gap: 20px;
    max-width: 90%;
  }

  /* Large: Maximum spacing */
  @media ${device.large} {
    max-width: 93%;
  }
`;

export const EventBorder = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
  gap: 8px;
  max-width: 100%;
  height: auto;
`;

export const TextElements = styled.div`
  max-width: 250px;
  width: 100%;
  max-height: 97px;
  height: auto;
  gap: 8px;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
`;

export const RightContainer = styled.div`
  width: auto;
  flex-shrink: 0;
  height: auto;
  display: flex;
  justify-content: center;
  align-self: stretch;
`;

export const TimeOfEvent = styled.div`
  width: 100%;
  max-height: 25px;
  height: auto;
  font-family: Verizon NHG DS;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 128.571%;
  letter-spacing: 0.5px;
`;

export const NameOfTheEvent = styled.div`
  width: 100%;
  max-height: 23px;
  height: auto;
  margin-top: 5px;
  padding: 0;
  align-self: stretch;
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-family: Verizon NHG DS;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const CameraNameofEvent = styled.div`
  width: 100%;
  max-height: 44px;
  margin-top: 5px;
  height: 100%;
  align-self: stretch;
  color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const TextEllipsis = styled.div`
  width: ${(props) => props.width || '20ch'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CaretButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-left: auto;
  width: auto;
  height: 24px;
  viewbox: 0 0 24 24;
  fill: none;
  transition: transform 0.3s ease;
`;

export const ExpandedFrame = styled.div`
  max-width: 390px;
  width: 100%;
  display: ${({ $isExpanded }) => ($isExpanded ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
  background: var(--vds-background-primary-light, #fff);
`;

export const SummaryofEvent = styled.div`
  width: 100%;
  max-height: 20px;
  height: auto;
  align-self: stretch;
  color: var(--vds-elements-text-icons-borders-secondary-onlight, #6f7171);
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  letter-spacing: 0.5px;
`;

export const TileForVideoPlayer = styled.div`
  width: 100%;
  height: 230px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(<path-to-image>),
    lightgray 50% / cover no-repeat;
`;

export const VideoPlayer = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: none;
  border: none;
  cursor: pointer;
`;

export const TileForButtons = styled.div`
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  align-self: stretch;
  margin-top: 20px;
`;
export const CustomButton = styled(Button)`
  width: 100%;
  max-height: 44px;
  display: flex;
  padding: var(--space-3-x, 12px) var(--space-6-x, 24px);
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 24px;
  background: ${(props) => (props?.disabled ? "grey" : "var(--vds-background-primary-dark, #000)")};
  cursor: pointer;
`;

//DashboardEventCard.jsx

export const EventTitle = styled.div`
  align-self: stretch;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px; /* Add margin-bottom to create a gap */
`;

export const CriticalHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-4-x, 16px);
  position: sticky;
  align-self: stretch;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 10px;
`;
//for mmp1
// export const CriticalNumber = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 68px;
//   width: 68px;
//   padding: 10px;
//   border-radius: 8px;
//   background: var(--vds-feedback-error-ondark, #ff8027);
//   color: #ffffff;
//   //font-family: Verizon NHG eDS;
//   font-size: 48px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 36px; /* 112.5% */
// `;

export const CriticalNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 10px;
  border-radius: 8px;
  background: var(--vds-feedback-error-ondark, #ff8027);
  color: #ffffff;
  //font-family: Verizon NHG eDS;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 112.5% */
  cursor: pointer;
`;

//for MMP1
// export const CriticalText = styled.div`
//   color: var(--vds-elements-text-icons-borders-primary-onlight, #000);
//   font-family: Verizon NHG DS;
//   font-size: 32px;
//   font-style: normal;
//   font-weight: 300;
//   line-height: 112.5%;
//   letter-spacing: 0.25px;
//   text-align: left;
// `;

//for EBC
export const CriticalText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
`;

export const HeadingWrapper = styled.div`
  width: 432px;
  height: 116px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-6-x, 24px);
  align-self: stretch;
`;

export const EventDeleteText = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #6f7171;
`;

export const FloorContainer = styled.div`
  /* Mobile: Full width */
  width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid #d8dada;
  color: #d8dada;
  margin-top: 12px;

  /* Tablet: Constrained width */
  @media ${device.tablet} {
    width: 100%;
    margin-top: 16px;
  }

  /* Desktop: Fixed width */
  @media ${device.desktop} {
    width: 524px;
    margin-top: 20px;
  }

  /* Large: Auto width */
  @media ${device.large} {
    width: auto;
  }
`;

export const VideoContainer = styled.div`
  /* Mobile/Tablet: Hidden */
  display: none;

  /* Desktop: Show full video */
  @media ${device.desktop} {
    display: block;
    flex: 1;
  }
`;

export const VideoSmallContainer = styled.div`
  /* Mobile/Tablet: Show small video */
  display: block;
  flex: 1;

  /* Desktop: Hidden (use full video) */
  @media ${device.desktop} {
    display: none;
  }
`;

export const EvidenceImageContainer = styled.div`
  /* Mobile: Full width, flexible direction */
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: ${({ isShowVideoContainer }) => (isShowVideoContainer ? "column" : "row")};
  gap: 16px;
  margin-top: ${({ isMediaUrl }) => (isMediaUrl ? "24px" : "20px")};

  /* Tablet: More spacing */
  @media ${device.tablet} {
    gap: 24px;
    margin-top: ${({ isMediaUrl }) => (isMediaUrl ? "30px" : "24px")};
  }

  /* Desktop: Maximum spacing */
  @media ${device.desktop} {
    gap: 30px;
    margin-top: ${({ isMediaUrl }) => (isMediaUrl ? "35px" : "30px")};
  }
`;

export const EventAndFloorContainer = styled.div`
  /* Mobile/Tablet: Row-reverse layout */
  display: flex;
  gap: 20px;
  flex-direction: row-reverse;
  flex: 1;

  /* Desktop: Column layout */
  @media ${device.desktop} {
    flex-direction: column;
    gap: 30px;
  }
`;

export const EventContainer = styled.div`
  background-color: #f6f6f6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  flex: 1;

  /* Mobile: Compact padding */
  padding: 16px;
  margin-top: 16px;

  /* Tablet: More padding */
  @media ${device.tablet} {
    padding: 18px;
    margin-top: 18px;
  }

  /* Desktop: Full padding, no top margin */
  @media ${device.desktop} {
    padding: 20px;
    margin-top: 0;
  }
`;

export const VideoPlayerContainer = styled.div`
  position: relative;
  margin: 5px 0;
  display: inline-block;
  z-index: 1;

  /* Mobile: Auto height, full width */
  width: 100%;
  height: auto;
  border-radius: 8px 0 0 0;

  /* Tablet: Slightly taller */
  @media ${device.tablet} {
    height: 350px;
  }

  /* Desktop: Fixed height */
  @media ${device.desktop} {
    height: 450px;
  }
`;

export const GreyTextHeader = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-size: 14px;
  font-weight: 1000;
  line-height: 30px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #6f7171;
  gap: 0px;
  opacity: 0px;
`;

export const AreaFloorText = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: Verizon NHG eDS;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
`;

export const SamllText = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: Verizon NHG DS;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

export const EventText = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
`;

export const InfoGreyTextHeader = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-size: 14px;
  font-weight: 1000;
  line-height: 30px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #6f7171;
  gap: 0px;
  opacity: 0px;
  margin-top: 0px;
`;
export const InfoText = styled.div`
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: Verizon NHG DS;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-align: left;
`;
export const ActivityLogContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;
export const EventIdTextWrapper = styled.div`
  display: block;
  white-space: nowrap;
  max-width: 100%;
  margin-top: 0.4rem;
`;

export const ResponsiveGrid = styled.div`
    display: grid;

    /* Mobile: Single column, everything stacks */
    gap: ${({ altLayout }) => (altLayout ? "16px" : "12px")};
    grid-template-areas: ${({ altLayout }) =>
      altLayout
        ? `"container3"
           "container4"
           "container2"
           "container5"`
        : `"container1"
           "container4"
           "container3"
           "container2"
           "container5"`};
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    /* Tablet: 2-column for info+floorplan, full-width for rest */
    @media ${device.tablet} {
      gap: ${({ altLayout }) => (altLayout ? "14px" : "10px")};
      grid-template-areas: ${({ altLayout }) =>
        altLayout
          ? `"container3"
             "container4"
             "container2"
             "container5"`
          : `"container4 container3"
             "container1 container1"
             "container2 container2"
             "container5 container5"`};
      grid-template-columns: ${({ altLayout }) => (altLayout ? "1fr" : "1fr 1fr")};
    }

    /* Large screens (>1272px) */
    @media (min-width: 1272px) {
      grid-template-areas: ${({ altLayout }) =>
        altLayout
          ? `"container3 container4"
             "container3 container5"
             "container2 empty"`
          : `"container1 container3"
             "container1 container4"
             "container2 container5"`};
      grid-template-columns: ${({ altLayout }) => (altLayout ? "3fr 2fr" : "62fr 38fr")};
      grid-template-rows: ${({ altLayout }) => (altLayout ? "auto auto auto" : "minmax(330px, auto) auto auto")};
      row-gap: ${({ altLayout }) => (altLayout ? "16px" : "40px")};
      column-gap: ${({ altLayout }) => (altLayout ? "16px" : "40px")};
    }
`;

export const Container1 = styled.div`
  grid-area: container1;
  background: #fff;
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Container2 = styled.div`
  grid-area: container2;
  background: #fff;
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  height: 100%;
`;

export const Container3 = styled.div`
  grid-area: container3;
  background: #fff;
  border-radius: 8px;
  min-width: 0;
  min-height: 300px;
  border: 1px solid #d8dada;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  @media (min-width: 1272px) {
    height: ${({ altLayout }) => (altLayout ? "540px" : null)};
    margin-top: ${({ statApp, altLayout }) => (statApp || altLayout ? "0" : "60px")};
  }
  @media (min-width: 1024px) and (max-width: 1271px) {
    height: ${({ altLayout }) => (altLayout ? "400px" : "330px")};
    max-height: ${({ altLayout }) => (altLayout ? "400px" : "none")};
  }
`;

export const Container4 = styled.div`
  grid-area: container4;
  background: #f6f6f6;
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  height: 100%;
  @media (min-width: 1680px) {
    height: ${({ altLayout }) => (altLayout ? "260px" : "auto")};
    max-height: ${({ altLayout }) => (altLayout ? "260px" : "none")};
  }
  @media (min-width: 1272px) and (max-width: 1679px) {
    height: ${({ altLayout }) => (altLayout ? "230px" : "auto")};
    max-height: ${({ altLayout }) => (altLayout ? "230px" : "none")};
  }
  @media (min-width: 1024px) and (max-width: 1271px) {
    height: auto;
    max-height: ${({ altLayout }) => (altLayout ? "200px" : "none")};
  }
  @media (max-width: 1023px) {
    height: auto;
    max-height: ${({ altLayout }) => (altLayout ? "180px" : "none")};
  }
`;

export const Container5 = styled.div`
  grid-area: container5;
  background: #fff;
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  height: 100%;
  @media (min-width: 1272px) and (max-width: 1679px) {
    height: ${({ altLayout }) => (altLayout ? "230px" : "auto")};
    max-height: ${({ altLayout }) => (altLayout ? "230px" : "none")};
  }
  @media (min-width: 1024px) and (max-width: 1271px) {
    height: auto;
    max-height: ${({ altLayout }) => (altLayout ? "200px" : "none")};
  }
  @media (max-width: 1023px) {
    height: auto;
    max-height: ${({ altLayout }) => (altLayout ? "180px" : "none")};
  }
`;
